module.exports = __webpack_public_path__ + "img/CRT_Spear-006.d61a24a4.png";